import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Emotions from './pages/Emotions';
import Experts from './pages/Experts';
import Blog from './pages/Blog';

// Corporate Pages
import CorporateRegister from './pages/CorporateRegister';
import CorporateDashboard from './pages/CorporateDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';

// Student & Parent Pages
import StudentParentAuth from './pages/StudentParentAuth';
import StudentDashboard from './pages/StudentDashboard';
import ParentDashboard from './pages/ParentDashboard';
import ForWomen from './pages/ForWomen';
import ForMen from './pages/ForMen';
import ForSeniors from './pages/ForSeniors';
import ForYouth from './pages/ForYouth';
import AdminQuestions from './pages/AdminQuestions';

import './App.css';

// Scroll to top on every route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// App Router with session_id detection
const AppRouter = () => {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/emotions" element={<Emotions />} />
      <Route path="/emotions/:emotion" element={<Emotions />} />
      <Route path="/for-women" element={<ForWomen />} />
      <Route path="/for-men" element={<ForMen />} />
      <Route path="/for-seniors" element={<ForSeniors />} />
      <Route path="/for-youth" element={<ForYouth />} />
      <Route path="/experts" element={<Experts />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<Blog />} />

      {/* Corporate Routes */}
      <Route path="/corporate/register" element={<CorporateRegister />} />
      <Route path="/corporate/dashboard" element={<CorporateDashboard />} />
      <Route path="/corporate/employee" element={<EmployeeDashboard />} />

      {/* Student & Parent Routes */}
      <Route path="/student-parent" element={<StudentParentAuth />} />
      <Route path="/student/dashboard" element={<StudentDashboard />} />
      <Route path="/parent/dashboard" element={<ParentDashboard />} />
      <Route path="/admin/questions" element={<AdminQuestions />} />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
